/**
 * Natura Karma — Product Form zorunlu alan bildirimi v2
 *
 * Görünmez overlay kullanmaz.
 * Mevcut <product-form> submitToCart metoduna bağlanır.
 * Pasif buton tıklanınca eksik alanları formun kendi [data-tf-error]
 * kutusunda gösterir ve ilk eksik alana kaydırır.
 */
(function () {
  'use strict';

  if (window.__TF_PRODUCT_FORM_VALIDATION_V2__) return;
  window.__TF_PRODUCT_FORM_VALIDATION_V2__ = true;

  var STYLE_ID = 'tf-product-form-validation-style';
  var ERROR_CLASS = 'tf-validation-summary';
  var MISSING_CLASS = 'tf-validation-missing';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      [data-tf-error].${ERROR_CLASS} {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        margin-top: 14px;
        border: 1px solid rgba(85, 93, 54, .22);
        border-radius: 12px;
        background: #f8f8f3;
        color: #44463a;
        font-size: 13px;
        line-height: 1.45;
        padding: 12px 14px;
      }

      [data-tf-error].${ERROR_CLASS}[hidden] {
        display: none !important;
      }

      .tf-validation-summary__icon {
        flex: 0 0 19px;
        display: grid;
        width: 19px;
        height: 19px;
        place-items: center;
        margin-top: 1px;
        border-radius: 50%;
        background: var(--tf-accent, #555d36);
        color: #fff;
        font-size: 11px;
        font-weight: 700;
      }

      .tf-validation-summary__body {
        min-width: 0;
      }

      .tf-validation-summary__title {
        display: block;
        margin-bottom: 4px;
        font-weight: 700;
      }

      .tf-validation-summary__items {
        display: flex;
        flex-wrap: wrap;
        gap: 5px 7px;
        margin: 0;
        padding: 0;
        list-style: none;
        color: #716f65;
      }

      .tf-validation-summary__items li:not(:last-child)::after {
        content: " ·";
      }

      .${MISSING_CLASS} {
        animation: tf-validation-nudge .45s ease;
      }

      .${MISSING_CLASS} input,
      .${MISSING_CLASS} select,
      .${MISSING_CLASS} textarea,
      .${MISSING_CLASS} .tf-choice-card {
        border-color: #a58059 !important;
        box-shadow: 0 0 0 2px rgba(165, 128, 89, .12) !important;
      }

      .btn-cart[aria-disabled="true"] {
        cursor: not-allowed;
      }

      @keyframes tf-validation-nudge {
        0%, 100% { transform: translateX(0); }
        35% { transform: translateX(-2px); }
        70% { transform: translateX(2px); }
      }

      @media (prefers-reduced-motion: reduce) {
        .${MISSING_CLASS} {
          animation: none;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function text(value) {
    return value == null ? '' : String(value).trim();
  }

  function isVisible(element) {
    if (!element || element.hidden) return false;

    var hiddenParent = element.closest('[hidden], [data-hidden="true"]');
    if (hiddenParent) return false;

    var style = window.getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Boolean(
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
      )
    );
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  }

  function cleanLabel(value) {
    return text(value)
      .replace(/\*/g, '')
      .replace(/\s+/g, ' ')
      .replace(/[:：]\s*$/, '');
  }

  function getSection(control) {
    return control.closest(
      '.tf-customization__section, .tf-field, fieldset'
    ) || control;
  }

  function getLabel(control) {
    var propertyName = control.getAttribute('data-property-name');
    if (propertyName) {
      var propertyMap = {
        'Teslimat Aralığı': 'Teslimat Saati',
        'Alıcının Telefonu': 'Alıcının Telefon Numarası',
        'Gönderim Bölgesi': 'Gönderim Bölgesi',
        'Gönderim Adresi': 'Gönderim Adresi'
      };

      return propertyMap[propertyName] || propertyName;
    }

    var section = getSection(control);
    var heading = section.querySelector(
      ':scope > .tf-customization__title, :scope > label, :scope > legend'
    );

    if (!heading) {
      heading = section.querySelector(
        '.tf-customization__title, .tf-field > label, legend'
      );
    }

    if (heading) return cleanLabel(heading.textContent);

    if (control.name === 'tf_delivery_date_choice') return 'Gönderim Günü';
    if (control.name === 'tf_delivery_slot') return 'Teslimat Saati';
    if (control.name === 'tf_note_choice') return 'Sipariş Notu Seçimi';
    if (control.name === 'tf_gift_choice') return 'Hediye Seçimi';

    return (
      cleanLabel(control.getAttribute('aria-label')) ||
      cleanLabel(control.getAttribute('placeholder')) ||
      'Zorunlu Alan'
    );
  }

  function controlIsEmpty(control, customization) {
    var type = text(control.type).toLowerCase();

    if (type === 'radio') {
      if (!control.name) return !control.checked;

      try {
        return !customization.querySelector(
          'input[type="radio"][name="' +
          CSS.escape(control.name) +
          '"]:checked'
        );
      } catch (_) {
        return !control.checked;
      }
    }

    if (type === 'checkbox') return !control.checked;

    return !text(control.value);
  }

  function collectMissing(customization) {
    var missing = [];
    var radioGroups = new Set();

    customization
      .querySelectorAll('input[required], select[required], textarea[required]')
      .forEach(function (control) {
        if (!isVisible(control)) return;

        var type = text(control.type).toLowerCase();
        if (type === 'hidden' || type === 'submit' || type === 'button') return;

        if (type === 'radio' && control.name) {
          if (radioGroups.has(control.name)) return;
          radioGroups.add(control.name);
        }

        if (!controlIsEmpty(control, customization)) return;

        missing.push({
          control: control,
          section: getSection(control),
          label: getLabel(control)
        });
      });

    var labels = new Set();

    return missing.filter(function (item) {
      var key = item.label.toLocaleLowerCase('tr-TR');
      if (labels.has(key)) return false;
      labels.add(key);
      return true;
    });
  }

  function clearMissing(customization) {
    customization
      .querySelectorAll('.' + MISSING_CLASS)
      .forEach(function (element) {
        element.classList.remove(MISSING_CLASS);
      });
  }

  function hideSummary(customization) {
    var errorBox = customization.querySelector('[data-tf-error]');
    if (!errorBox) return;

    if (errorBox.classList.contains(ERROR_CLASS)) {
      errorBox.hidden = true;
      errorBox.innerHTML = '';
    }
  }

  function showMissing(customization) {
    var errorBox = customization.querySelector('[data-tf-error]');
    if (!errorBox) return false;

    clearMissing(customization);

    var missing = collectMissing(customization);

    if (!missing.length) {
      errorBox.classList.add(ERROR_CLASS);
      errorBox.innerHTML =
        '<span class="tf-validation-summary__icon">!</span>' +
        '<div class="tf-validation-summary__body">' +
          '<strong class="tf-validation-summary__title">' +
            'Lütfen seçimlerinizi kontrol edin.' +
          '</strong>' +
          '<span>Eksik bir zorunlu alan bulunuyor.</span>' +
        '</div>';
      errorBox.hidden = false;
      return false;
    }

    missing.forEach(function (item) {
      item.section.classList.add(MISSING_CLASS);
    });

    var list = missing
      .slice(0, 8)
      .map(function (item) {
        return '<li>' + escapeHtml(item.label) + '</li>';
      })
      .join('');

    if (missing.length > 8) {
      list += '<li>+' + (missing.length - 8) + ' alan</li>';
    }

    errorBox.classList.add(ERROR_CLASS);
    errorBox.innerHTML =
      '<span class="tf-validation-summary__icon">!</span>' +
      '<div class="tf-validation-summary__body">' +
        '<strong class="tf-validation-summary__title">' +
          'Siparişi tamamlamak için' +
        '</strong>' +
        '<ul class="tf-validation-summary__items">' +
          list +
        '</ul>' +
      '</div>';
    errorBox.hidden = false;

    var first = missing[0];
    var target = first.section || first.control;

    window.setTimeout(function () {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

      window.setTimeout(function () {
        try {
          first.control.focus({ preventScroll: true });
        } catch (_) {
          try {
            first.control.focus();
          } catch (__) {}
        }
      }, 350);
    }, 80);

    return true;
  }

  function findCustomization(productForm) {
    var form = productForm.querySelector('form');
    var productSection = productForm.closest(
      '.shopify-section, .product-info, .main-product'
    );

    return (
      (form && form.querySelector('[data-tf-customization]')) ||
      (productSection &&
        productSection.querySelector('[data-tf-customization]'))
    );
  }

  function keepValidationButtonClickable(productForm, button, customization) {
    if (!button || button.dataset.tfValidationReady === 'true') return;

    button.dataset.tfValidationReady = 'true';

    function syncDisabledState() {
      var isSubmitting =
        button.getAttribute('data-tf-submitting') === 'true';

      var logicalDisabled =
        button.getAttribute('data-disabled') === 'true' ||
        button.getAttribute('aria-disabled') === 'true' ||
        button.disabled;

      if (logicalDisabled && !isSubmitting) {
        button.setAttribute('aria-disabled', 'true');

        /*
         * Native disabled düğme click olayı üretmez.
         * Form doğrulama döneminde disabled kaldırılır; data-disabled
         * ve aria-disabled pasif görünümü/işlevi korur.
         */
        if (button.disabled) button.disabled = false;
        button.removeAttribute('disabled');
      }

      if (!logicalDisabled) {
        button.setAttribute('aria-disabled', 'false');
      }
    }

    customization.addEventListener('input', function () {
      clearMissing(customization);
      hideSummary(customization);
    });

    customization.addEventListener('change', function () {
      clearMissing(customization);
      hideSummary(customization);
    });

    new MutationObserver(syncDisabledState).observe(button, {
      attributes: true,
      attributeFilter: [
        'disabled',
        'data-disabled',
        'aria-disabled',
        'data-tf-submitting',
        'class'
      ]
    });

    syncDisabledState();
  }

  function patchProductForm() {
    var ProductForm = customElements.get('product-form');
    if (!ProductForm || ProductForm.prototype.__tfValidationPatched) return false;

    ProductForm.prototype.__tfValidationPatched = true;

    var originalInit = ProductForm.prototype.init;
    var originalSubmitToCart = ProductForm.prototype.submitToCart;

    ProductForm.prototype.init = function () {
      originalInit.apply(this, arguments);

      var customization = findCustomization(this);
      if (customization && this.btnCart) {
        keepValidationButtonClickable(
          this,
          this.btnCart,
          customization
        );
      }
    };

    ProductForm.prototype.submitToCart = function (event) {
      var button = event.currentTarget || this.btnCart;
      var customization = findCustomization(this);

      if (
        customization &&
        button &&
        button.getAttribute('data-disabled') === 'true' &&
        button.getAttribute('data-tf-submitting') !== 'true'
      ) {
        event.preventDefault();
        event.stopPropagation();
        showMissing(customization);
        return;
      }

      /*
       * Aktif düğme orijinal metoda bırakılır.
       * Orijinal metot validasyondan geçerse düğmeyi senkron biçimde
       * disabled yapar; bunu ağ isteği süresince gerçek disabled olarak tutarız.
       */
      if (button) {
        button.setAttribute('data-tf-submitting', 'true');
      }

      var result;

      try {
        result = originalSubmitToCart.apply(this, arguments);
      } finally {
        if (button) {
          window.setTimeout(function () {
            var requestStarted =
              button.getAttribute('data-disabled') === 'true' &&
              button.disabled;

            if (!requestStarted) {
              button.removeAttribute('data-tf-submitting');
            }
          }, 0);

          var submissionObserver = new MutationObserver(function () {
            if (button.getAttribute('data-disabled') !== 'true') {
              button.removeAttribute('data-tf-submitting');
              submissionObserver.disconnect();
            }
          });

          submissionObserver.observe(button, {
            attributes: true,
            attributeFilter: ['data-disabled']
          });
        }
      }

      return result;
    };

    /*
     * Sayfada product-form elemanları patch uygulanmadan önce oluşmuşsa
     * mevcut butonları da hazırla.
     */
    document.querySelectorAll('product-form').forEach(function (productForm) {
      var customization = findCustomization(productForm);
      var button = productForm.querySelector('.btn-cart');

      if (customization && button) {
        keepValidationButtonClickable(
          productForm,
          button,
          customization
        );
      }
    });

    return true;
  }

  function init() {
    injectStyles();

    if (patchProductForm()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;

      if (patchProductForm() || attempts >= 100) {
        window.clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
